<template>
    <atomic-layout-section section="results">
        <atomic-smart-snippet></atomic-smart-snippet>
        <atomic-smart-snippet-suggestions></atomic-smart-snippet-suggestions>
        <atomic-result-list density="compact" image-size="none" display="grid">
          <atomic-result-template v-html="hcxfPublicationResultTemplate"></atomic-result-template>
        </atomic-result-list>
        <atomic-query-error></atomic-query-error>
        <atomic-no-results></atomic-no-results>
    </atomic-layout-section>
</template>

<script>
  import hcxfPublicationResultTemplate from './hcxf-publication-result-template.html?raw';

  export default {
    data: function() {
      return {
        hcxfPublicationResultTemplate: hcxfPublicationResultTemplate,
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/app/components/hcxf/hcxf-publication-search-results.vue